import React from "react";
import { motion } from "framer-motion";
import {
  AccordionContainer,
  AccordionItem,
  AccordionHeader,
  AccordionIcon,
  AccordionContent,
  AccordionDescription
} from "./AccordionStyles";

export default function Accordion({ items, activeIndex, onToggle }) {
  return (
    <AccordionContainer>
      {items.map((item, index) => (
        <AccordionItem 
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
        >
          <AccordionHeader 
            onClick={() => onToggle(index)}
            $isActive={activeIndex === index}
          >
            <span>{item.title}</span>
            <AccordionIcon>
              {activeIndex === index ? '-' : '+'}
            </AccordionIcon>
          </AccordionHeader>
          <AccordionContent 
            initial={false}
            animate={{
              height: activeIndex === index ? 'auto' : 0,
              opacity: activeIndex === index ? 1 : 0
            }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <AccordionDescription>
              {item.description}
            </AccordionDescription>
          </AccordionContent>
        </AccordionItem>
      ))}
    </AccordionContainer>
  );
}